import React from "react";
import "./CryptoXStocks.css";
import image from "./image.png";
import image1 from "./appleStore.png";
import image2 from "./playStore.png";

import { LazyLoadImage } from "react-lazy-load-image-component";
const APKLink = `${process.env.REACT_APP_FRONTEND_URL}/WLF-Mobile.apk`;

const CryptoXStocks = () => {

    const DownloadFun = (url) => {
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.setAttribute("download", fileName);
    document.body.appendChild(aTag);
    aTag.click();
    document.body.removeChild(aTag);
  };

  return (
    <>
      <section className="crypto-xstocks-section">
        <div className="container">
        <div className="crypto-xstock-area">
            <div className="crypto-xstocks-image">
            <LazyLoadImage alt="img" effect="blur" src={image} />
          </div>
          <div className="crypto-xstocks-content-area">
            <div className="d-flex align-items-center justify-content-center">
              <div className="crypto-xstocks-content-star">
                <h4>*</h4>
              </div>
              <div className="crypto-xstocks-content">
                <h3>Crypto</h3>
                <h3>xStocks</h3>
                <h3>Gold</h3>
                <h3>Forex</h3>
              </div>
            </div>
            <div className="crypto-xstocks-footer-area">
              <p>
                All your investments. All on WLF <br /> Finance. Download the
                mobile <br /> application to operate smoothly.
              </p>

              <div className="crypto-xstocks-footer-link-area">
                <button  className="pe-2">
                  <LazyLoadImage alt="img" effect="blur" src={image1} />
                </button>
                <button onClick={() => DownloadFun(APKLink)}>
                  <LazyLoadImage alt="img" effect="blur" src={image2} />
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>
    </>
  );
};

export default CryptoXStocks;
